import { List } from 'immutable';
import { lruMemoize } from 'reselect';

import {
    isResourceLoading,
    getResourceTotal,
    getResourcePage,
    getResourcePerPage,
} from './common';

const isSearchLoading = lruMemoize(isResourceLoading);
const getSearchTotal = getResourceTotal;
const getSearchPage = getResourcePage;
const getSearchPerPage = getResourcePerPage;
const getSearchResults = lruMemoize(
    (data) => data.get('results', List()),
);

export {
    isSearchLoading,
    getSearchTotal,
    getSearchPage,
    getSearchPerPage,
    getSearchResults,
};
